define([
    'santa-components',
    'lodash',
    'coreUtils',
    'socialCommon',
    'components',
    'skins',
    'wTwitterFollow/skins/skins.json',
    'componentsCore'
], function (
    santaComponents,
    _,
    coreUtils,
    socialCommon,
    components,
    skinsPackage,
    skinsJson,
    componentsCore
) {
    'use strict';

    function getScreenName(compData) {
        return compData.accountToFollow.replace('@', '');
    }

    /**
     * @class components.WTwitterFollow
     * @extends {core.skinBasedComp}
     */
    //eslint-disable-line santa/no-module-state
    const comp = {
        displayName: 'WTwitterFollow',
        mixins: [componentsCore.mixins.skinBasedComp, socialCommon.twitterComponentMixin],
        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            id: santaComponents.santaTypesDefinitions.Component.id.isRequired,
            origin: santaComponents.santaTypesDefinitions.Location.origin,
            santaBase: santaComponents.santaTypesDefinitions.santaBase.isRequired
        },
        getIFrameSrc() {
            const screenName = getScreenName(this.props.compData);

            const urlParams = {
                screen_name: screenName,
                href: `https://twitter.com/${screenName}`,
                show_count: this.props.compProp.showCount.toString(),
                show_screen_name: this.props.compProp.showScreenName.toString(),
                lang: this.getLanguage(),
                align: 'left',
                compId: this.props.id,
                origin: this.props.origin,
                widgetType: 'FOLLOW'
            };

            return `${this.props.santaBase}/static/external/twitter.html?${coreUtils.urlUtils.toQueryString(urlParams)}`;
        },

        getIframeTitleName() {
            return 'component_label_ twitterTweetTitle';
        }
    };

    // And register yourself
    componentsCore.compRegistrar.register('wysiwyg.viewer.components.WTwitterFollow', comp);
    components.translationRequirementsChecker.registerCommonLanguageRequirement(
        'wysiwyg.viewer.components.WTwitterFollow',
        (siteData, compInfo) => _.get(compInfo, ['properties', 'dataLang']));
    skinsPackage.skinsMap.addBatch(skinsJson);

    return comp;
});
